var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container"},[_c('h1',[_vm._v("欢迎登录格隆汇活动系统~"+_vm._s(_vm.user))]),_vm._v(" "),_c('p',[_vm._v("现在是北京时间："+_vm._s(_vm.time)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_5456a318c21f0d6ee57754f126b5f593/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afc00cc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_5456a318c21f0d6ee57754f126b5f593/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/default.vue
// module id = zuzN
// module chunks = 2